import React from 'react';
import { Box, Typography } from '@mui/material';

/*
  EmptyState: friendly placeholder when a list/section has no data.
  Props:
   - icon: React node (rendered inside a muted circle)
   - title: string
   - description: string | node
   - action: React node (e.g. a "Clear filters" or "Add" button)
   - dense: tighter vertical padding for in-card use
   - sx: overrides
*/

export default function EmptyState({ icon, title, description, action, dense = false, sx }) {
  return (
    <Box sx={{ textAlign: 'center', py: dense ? 3 : 6, px: 2, ...sx }}>
      {icon && (
        <Box
          sx={{
            width: 56,
            height: 56,
            mx: 'auto',
            mb: 1.5,
            borderRadius: '50%',
            bgcolor: 'grey.100',
            color: 'text.secondary',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& svg': { fontSize: 28 },
          }}
        >
          {icon}
        </Box>
      )}
      {title && (
        <Typography variant="h6" fontWeight={600} gutterBottom>
          {title}
        </Typography>
      )}
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420, mx: 'auto' }}>
          {description}
        </Typography>
      )}
      {action && <Box sx={{ mt: 2.5 }}>{action}</Box>}
    </Box>
  );
}
